import { FC, useState } from "react";
import EditInputField from "../edit-input-field/EditInputField";
import { VerificationCodeInputMD } from "../verification-code-input/VerificationCodeInputMD";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import { useCountdown } from "../../../hooks/CountDown";
import { toastError } from "../../../utils/toast";
import {
  onExpireOtpCode,
  sendOtpCode,
} from "../../../redux/requests/IdentificationRequests";
import { isOnlyDigits } from "../../../utils/dateService";

interface IPhoneVerificationProps {
  isActive: boolean;
  setIsActive: Function;
  ref: any;
}

const PhoneVerification: FC<IPhoneVerificationProps> = ({
  isActive,
  ref,
  setIsActive,
}) => {
  const otp = useAppSelector((state) => state.user.otp);

  const dispatch = useAppDispatch();

  const { hours, minutes, seconds } = useCountdown(otp.expireAt, () => {
    dispatch(onExpireOtpCode());
  });

  const [phone, setPhone] = useState<string>("992");
  const [code, setCode] = useState<string>("");
  const isLoading = false;

  const onSendMessageClick = () => {
    if (!isOnlyDigits(phone)) {
      toastError("Введите корректный номер телефона!");
      return;
    }
    if (phone.length === 9 || phone.length === 12) {
      dispatch(sendOtpCode(phone));
    } else {
      toastError("Введите корректный номер телефона!");
      return;
    }
  };

  return (
    <div
      tabIndex={-1}
      className={`${
        isActive ? "" : "hidden"
      } overflow-y-auto overflow-x-hidden absolute z-50 items-center md:inset-0 h-full w-full flex justify-center align-middle bg-[#00000056]`}
    >
      <div
        className="relative p-4 w-full max-w-md max-h-full bg-white"
        ref={ref}
      >
        <div className="relative bg-neutral-primary-soft border border-default rounded-base shadow-sm p-4 md:p-6">
          <div className="flex items-center justify-between border-b border-default pb-4 md:pb-5">
            <h3 className="text-lg font-medium text-heading">
              Изменение номер телефона
            </h3>
            <button
              type="button"
              className="text-body bg-transparent hover:bg-neutral-tertiary hover:text-heading rounded-base text-sm w-9 h-9 ms-auto inline-flex justify-center items-center"
              onClick={() => setIsActive(false)}
            >
              <svg
                className="w-5 h-5"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
          </div>
          <div className="pt-4 md:pt-6">
            {!otp.wasTheCodeSent && (
              <EditInputField
                data={{
                  id: 20,
                  type: "text",
                  value: phone,
                  labelText: "Введите номер телефона",
                }}
                readonly={false}
                setValue={setPhone}
                maxLength={12}
              />
            )}

            {otp.wasTheCodeSent && <VerificationCodeInputMD phone={phone} />}
          </div>
          <button
            className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none w-full mt-4 disabled:bg-gray-500 disabled:hover:bg-gray-500"
            disabled={otp.wasTheCodeSent}
            onClick={onSendMessageClick}
          >
            {otp.expireAt && minutes
              ? `${minutes}:${seconds.toString().padStart(2, "0")}`
              : "Отправить SMS код"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhoneVerification;
